var twitter = "//s3.amazonaws.com/edge-assets.lemonade.com/twitter-a306a57e98d33b5bfcb39356e59d864a.svg";

export { twitter as default };
